export default "/images/baa60e287e9a09142d9797c5d2707d82.avif";